export default __webpack_public_path__ + "static/lysicrates-torn-parper-nav-bar-bottom-V2-92feb81f1bd4c70c7c03f1c884425a1d.png";